<template>
    <div class="parent">
        <!-- 联系我们
        <MyTitle text="联系我们"/> -->
        <div class='footer'>
            <div class="fContent showPc">
                <div class="fCson">
                    <div class="fTel">
                        <img src="~assets/img/phone.png" alt="">
                        <span>400-8385-525 +86-571-82131525</span>
                    </div>
                    <div class="fTel">
                        <img class="mess" src="~assets/img/message.png" alt="">
                        customer@itepchina.cn   
                    </div>
                    <div class="fTel">
                        <img class="mess" src="~assets/img/earth.png" alt="">
                        ©2020 iTEP. All Rights Reserved.&nbsp;&nbsp;&nbsp; <span @click="linkClick">晋ICP备19009313号-1</span>
                    </div>
                </div>
                <div class="fRight">
                    <div class="imgItem">
                        <div class="txt">iTEP易特</div>
                        <img src="~assets/img/qrCode.jpeg" alt="">
                    </div>
                    <div class="imgItem">
                        <div class="txt">iTEP两易</div>
                        <img src="~assets/img/testCode.jpeg" alt="">
                    </div>
                </div>
            </div>
            <div class="mContent showMobile">
                    <div class="mFright">
                        <div class="mTel">
                            <img src="~assets/img/phone.png" alt="">
                            <span>400-8385-525 +86-571-82131525</span>
                        </div>
                        <div class="mTel mTel2">
                            <img class="mess" src="~assets/img/message.png" alt="">
                            customer@itepchina.cn
                        </div>
                        <div class="mTel">
                            <img src="~assets/img/earth.png" alt="">
                            ©2020 iTEP. All Rights Reserved. <br/><span @click="linkClick">晋ICP备19009313号-1</span>
                        </div>
                    </div>
                    <div class="mFleft">
                        <div class="imgItem">
                            <img src="~assets/img/qrCode.jpeg" alt="">
                            <div class="txt">iTEP易特</div>
                        </div>
                        <div class="imgItem">
                            <img src="~assets/img/testCode.jpeg" alt="">
                            <div class="txt">iTEP两易</div>
                        </div>
                    </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            linkClick(){
                window.open('https://beian.miit.gov.cn/')
            }
        }
    }
</script>
<style scoped>
.footer{
    height:160px;
    background: var(--color-main);
    color:#fff;
}
.fContent{
    height:100%;
    width:var(--width-main);
    margin:0 auto;
    display:flex;
    justify-content: space-between;
    padding:20px 0;
}
.fContent .fCson{   
    display: flex;
    flex-direction: column;
    justify-content: space-around; 
}
.fTel{
    position: relative;
    padding-left:40px;
}
.fTel span{
    cursor: pointer;
}
.fTel img{
    height:20px;
    position: absolute;
    top:0;
    left:0;
}
.fTel img.mess{
    height: 23px;
    top:-1px;
}
.fContent .fRight{
    height: 100%;
    display: flex;
    text-align: center;
}
.fRight .imgItem:nth-child(1){
    margin-right:30px;
}
.fRight .imgItem .txt{
    line-height: 30px;
    font-size:15px;
}
.fContent .fRight img{
    height: 80px;
}

@media screen and (max-width: 768px){
    .footer{
        height:2.4rem;
        padding:0.2rem 0.3rem;
        width:100%;
    }
    .fContent{
        display: none;
    }
    .mFright{
        width: 69%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
    }
    .mFright .mTel:nth-child(3){
        line-height: 0.35rem;
    }
    .mFleft{
        width: 31%;
        display: flex;
        justify-content: space-between;
    }
    .mFleft .imgItem img{
        margin-top:0.2rem;
        height:1rem;
    }
    .mFleft .imgItem .txt{
        margin-top:0.2rem;
        text-align: center;
    }
    .mContent{
        width: 100%;
        height:100%;
        font-size:0.24rem;
        display: flex;
        justify-content:space-between;
    }
    .mTel{
        position: relative;
        padding-left:0.5rem;
    }
    .mTel2{
        font-size: 0.26rem;
    }
    .mTel img{
        height:0.3rem;
        position: absolute;
        top:0;
        left:0;
    }
}
</style>